<template>
    <div class="jubao">
        <!-- 青少年举报中心 -->
        <div class="kapian">
            <div class="daohang">
                <p>提交反馈</p>
            </div>
            <div class="">
                <div class="neirong">
                    <p class="p_leixing"><span>⁎</span>反馈类型：</p>
                    <!-- <el-radio v-model="radio" label="1">建议</el-radio> -->
                    <el-radio v-model="radio" label="1">问题</el-radio>
                </div>
                <div class="neirong">
                    <p class="p_leixing"><span>⁎</span>反馈分类：</p>
                    <el-select v-model="value" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="neirong2">
                    <p class="p_leixing"><span>⁎</span>反馈内容：</p>
                    <el-input class="textrareas_yangshi" type="textarea" v-model="Text_shuru" :rows="4" placeholder="请输入内容"></el-input>
                </div>
                <div class="neirong3">
                    <p class="p_leixing"><span> </span>图片/截图：</p>
                    <div class="shangchuan_div">
                        <img :src="sc_Img" alt="" > 
                        <input type="file" @change="onFileChange">
                    </div>
                </div>
                <div class="quren_tijiao" @click="JBqueren()">确认提交</div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        name: "jubao",
        data() {
            return{
                radio:'1',
                options: [
                    {
                        value: '1',
                        label: '青少年有害内容举报'
                    },
                    {
                        value: '2',
                        label: '建议反馈'
                    }
                ],
                sc_Img:require('../../assets/shangchuan.png'),
                value: '',
                Text_shuru:''
            }
        },
        methods:{
            //上传图片
            onFileChange(e){
                const file = e.target.files[0];
                
                const reader = new FileReader();
			    reader.readAsDataURL(file);
                reader.onload = (result)=>{
                    console.log(result);
                    this.sc_Img = result.target.result;
                    // axios.post('api/index/fankui',this.sc_Img,{
                    //         headers: {
                    //         'Content-Type': 'multipart/form-data'
                    //         }
                    //     })
                    //     .then(response => {
                    //         // 处理请求成功的响应
                    //         console.log(response.data);
                            
                    //     })
                    //     .catch(error => {
                    //         // 处理请求失败的错误
                    //         console.error(error);
                    //     });
			    }
            },
            //确认提交
            JBqueren(){
                if(this.$store.state.LoginStatus!==''){//判断用户是否登录 !==''是 ''不是
                    if(this.value!=='' && this.Text_shuru !==''){
                        this.$message.success('提交成功，已反馈给管理员');
                        this.$router.push('/home');
                        // const reader = new  FormData();
                        // reader.append('file', this.sc_Img);
                        // reader.append('phoness', this.$store.state.LoginStatus.phone);
                        // reader.append('fenlei', this.value);
                        // reader.append('content', this.Text_shuru);
                       
                        
                        // axios.post('api/index/fankui',reader,{
                        //     headers: {
                        //     'Content-Type': 'multipart/form-data'
                        //     }
                        // })
                        // .then(response => {
                        //     // 处理请求成功的响应
                        //     console.log(response.data);
                            
                        // })
                        // .catch(error => {
                        //     // 处理请求失败的错误
                        //     console.error(error);
                        // });
                    }else{
                        this.$message.warning('必填项不能为空！');
                    }

                }else{
                    this.$message.warning('请先登录');
                }
            }
        }
    }
</script>
<style lang="scss">
    .jubao{
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .kapian{
            width: 1000px;
            height: 500px;
            overflow: hidden;
            border: solid 1px var(--qn-border-color);
            border-radius: 10px;
            margin-top: 100px;
            position: relative;
            .daohang{
                width: 100%;
                height: 60px;
                background-color: rgb(121, 170, 255);
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                color: white;
                font-weight: bold;
            }
            .neirong{
                display: flex;
                align-items: center;
                margin-left: 30px;
                margin-top: 25px;
                height: 30px;
                
            }
            .neirong2{
                display: flex;
                align-items: flex-start;
                margin-left: 30px;
                margin-top: 25px;
                
                .textrareas_yangshi{
                    width: 300px;
                    height: 20px;
                    
                }
             
            }
            .neirong3{
                display: flex;
                align-items: center;
                margin-left: 30px;
                margin-top: 160px;
                .shangchuan_div{
                    width: 80px;
                    height: 80px;
                    border: solid 1px var(--qn-border-color);
                    border-radius: 3px;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    color: var(--qn-fize-color2);
                    position: relative;
                    
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    input{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        cursor: pointer;
                    }
                }
            }
            .quren_tijiao{
                width: 100px;
                height: 40px;
                background-color: rgb(121, 170, 255);
                border-radius: 5px;
                text-align: center;
                position: absolute;
                line-height: 40px;
                color: #fff;
                right: 30px;
                bottom: 30px;
                font-size: 15px;
                cursor: pointer;
                transition: 0.2s;
            }
            .quren_tijiao:hover{
                transition: 0.2s;
                background-color: rgb(54, 128, 255);
            }
        }
        
        
    }
        .p_leixing {
            span {
                color: red;
                margin-right: 5px;
            }
            font-size: 15px;
            line-height:30px;
            color: var(--qn-fize-color);
            margin-right: 15px;
        }
        .el-textarea__inner{
            border: solid 1px var(--qn-border-color) !important;
           background-color: var(--qn-texttarea) !important;
        }
        .el-textarea__inner:focus{
            border: solid 1px #409EFF !important;
        }
</style>